import { defineMessages } from 'react-intl';

/** i18n for Rudo API-token connect flow. */
export const rudoConnectMessages = defineMessages({
  connectApiKeyTitle: {
    id: 'socialExport.rudo.connectApiKeyTitle',
    defaultMessage: 'Conectar Rudo con access token',
  },
  accessToken: {
    id: 'socialExport.rudo.accessToken',
    defaultMessage: 'Access token',
  },
  accessTokenHelper: {
    id: 'socialExport.rudo.accessTokenHelper',
    defaultMessage: 'Token estático de tu cuenta de Rudo.video',
  },
  displayName: {
    id: 'socialExport.rudo.displayName',
    defaultMessage: 'Nombre para mostrar',
  },
  displayNameHelper: {
    id: 'socialExport.rudo.displayNameHelper',
    defaultMessage: 'Opcional. Útil si conectás más de una cuenta de Rudo.',
  },
});
